import { namespace } from 'vuex-class';
import { ESortByType } from '../contracts-table/types/enums/sort-by-type';
import { ESortOrder } from '../contracts-table/types/enums/sort-order';
import { IContractManagementState } from './contract-management.types';

export const ContractManagement = namespace('contractManagement');

export function getDefaultState(): IContractManagementState {
  return {
    loadingDocuments: false,
    loadedDocuments: false,

    loadingKeyValues: false,
    loadedKeyValues: false,

    keyValues: {
      sum: 0,
      count: 0,
      average: 0,
    },
    documents: [],

    selectedDocumentIds: [],

    filterRanges: null,
    filterActive: false,
    payload: {
      offset: 0,
      limit: 20,
      searchPhrases: [],
      sortBy: ESortByType.SignDate,
      sortOrder: ESortOrder.Desc,
      filter: null,
      folderId: null,
    },

    breadcrumb: [],
    folders: [],
    selectedFolder: null,
    folderTree: null,

    tags: [],
    documentNotifications: [],
  };
}

export enum EContractManagementAction {
  LoadDocuments = 'loadDocuments',
  LoadDocumentsSuccess = 'loadDocumentsSuccess',

  LoadKeyValues = 'loadKeyValues',
  LoadKeyValuesSuccess = 'loadKeyValuesSuccess',

  RemoveDocumentTags = 'removeTags',
  UpdateDocumentOwner = 'updateDocumentOwner',
  UpdateNotification = 'updateNotification',

  LoadFilterRanges = 'loadFilterRanges',
  SetFilterActive = 'setFilterActive',
  UpdatePayload = 'updatePayload',
  SetFolderIdFromRoute = 'setFolderIdFromRoute',
  OpenFolder = 'openFolder',

  MoveDocuments = 'moveDocuments',

  DeleteDocuments = 'deleteDocuments',
  DeleteDocumentsSuccess = 'deleteDocumentsSuccess',

  UploadDocument = 'uploadDocument',
  UploadDocumentSuccess = 'uploadDocumentSuccess',

  LoadTags = 'loadTags',
  LoadTagsSuccess = 'loadTagsSuccess',

  CreateTag = 'createTags',
  CreateTagSuccess = 'createTagsSuccess',
  CreateTagFailed = 'createTagsFailed',

  AddTagsToDocuments = 'addTagsToDocuments',
  AddTagsToDocumentsSuccess = 'addTagsToDocumentsSuccess',

  RemoveAllTags = 'removeAllTags',
  RemoveAllTagsSuccess = 'removeAllTagsSuccess',

  DownloadDocuments = 'downloadDocuments',
  DownloadToClient = 'downloadToClient',
  DownloadFailed = 'downloadFailed',

  CreateNotifications = 'createNotifications',
  CreateNotificationsSuccess = 'createNotificationsSuccess',

  DeleteNotifications = 'deleteNotifications',
  DeleteNotificationsSuccess = 'deleteNotificationsSuccess',
  DeleteNotificationsFailed = 'deleteNotificationsFailed',

  LoadFolderTree = 'loadFolderTree',
  LoadFolderTreeSuccess = 'loadFolderTreeSuccess',

  UpdateDocuments = 'updateDocuments',
  UpdateDocumentsSuccess = 'updateDocumentsSuccess',

  LoadDocumentNotifications = 'loadDocumentNotifications',
  LoadDocumentNotificationsSuccess = 'loadDocumentNotificationsSuccess',

  ToggleSelectDocument = 'toggleSelectDocument',
  ToggleSelectAllDocuments = 'toggleSelectAllDocuments',
  DeselectAllDocuments = 'deselectAllDocuments',
}

export enum EContractManagementMutation {
  SetLoadingDocuments = 'setLoadingDocuments',
  SetLoadedDocuments = 'setLoadedDocuments',

  SetLoadingKeyValues = 'setLoadingKeyValues',
  SetLoadedKeyValues = 'setLoadedKeyValues',

  DeleteDocuments = 'deleteDocuments',
  EditDocuments = 'editDocuments',
  SetDocuments = 'setDocuments',
  SetKeyValues = 'setKeyValues',

  SetPayload = 'setPayload',
  SetFilterRanges = 'setFilterRanges',
  SetFilterActive = 'setFilterActive',

  LoadFolderTree = 'loadFolderTree',

  AddTag = 'addTag',
  SetTags = 'setTags',

  SetDocumentNotifications = 'setDocumentNotifications',
  AddDocumentNotifications = 'addDocumentNotifications',
  DeleteDocumentNotifications = 'deleteDocumentNotification',

  SetSelectedDocuments = 'setSelectedDocuments',
}

export enum EContractManagementGetter {
  SelectedDocuments = 'selectedDocuments',
  ShowFooterBar = 'showFooterBar',
}
